import parse from 'html-react-parser';
import React, { memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  isHiddenInPrint,
  itemTitleStyle,
  lineHeightStyle,
  styledComponent,
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';

const SpecialNoteView = ({
  selectedSpecialNotes,
  setSelectedSpecialNotes,
  setShowSpecialNote,
  prescriptionItems,
  element,
  isHistoryPage = false,
}) => {
  const Title = styledComponent(
    prescriptionItems?.items?.['special-note']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['special-note']?.subItemStyle || {},
  );
  const deleteSpecialNote = (specialNoteId) => {
    selectedSpecialNotes = selectedSpecialNotes.filter(
      (specialNote) => specialNote?.note !== specialNoteId,
    );
    setSelectedSpecialNotes([...selectedSpecialNotes]);
  };

  return (
    <div
      className={`row item-row special-note-view ${
        selectedSpecialNotes?.length ? 'data-item' : 'no-data-item'
      }`}
    >
      <span
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'special-note')
            ? 'item-title-hide'
            : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.['special-note']?.itemStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowSpecialNote(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span>Special Note</span>
        )}
      </span>
      <ul
        className="sub-child-list special-note-view"
        style={lineHeightStyle('special-note', prescriptionItems)}
      >
        {selectedSpecialNotes?.map((item, index) => {
          if (item.groupName || item.note) {
            return (
              <li key={index}>
                {item?.groupName && (
                  <>
                    <Row className="">
                      <Col className="groupName">
                        <Title>{item.groupName}</Title>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="special-note">
                        <Value>{parse(item.note)}</Value>
                      </Col>
                      <Col sm={1}>
                        <CommonDeleteBtn
                          action={deleteSpecialNote}
                          itemName={item?.note}
                          delId={''}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {!item?.groupName && item.note && (
                  <Row>
                    <Col className="special-note">{parse(item.note)}</Col>
                    <Col sm={1}>
                      <CommonDeleteBtn
                        action={deleteSpecialNote}
                        itemName={item?.note}
                        delId={''}
                      />
                    </Col>
                  </Row>
                )}
              </li>
            );
          }
        })}
      </ul>
    </div>
  );
};

export default memo(SpecialNoteView);
